import { useContext } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Box, Button, DashboardModule } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'
import type { DefaultContext } from '@contexts/pageContext'

import type { PageContextPayload } from '@sections/Admin/packs/Projects/screens/Detail/screens/Overview'

import useRelatedEntity from '@hooks/useRelatedEntity'
import useRelatedEntities from '@hooks/useRelatedEntities'

import type { TaskListModel } from '@models/types'

import RelatedEntity from './RelatedEntity'

interface ContactsProps {
  taskList: TaskListModel,
}

const Contacts = (props: ContactsProps) => {
  const { taskList } = props

  // @ts-expect-error TS2345
  const pageContext = useContext<DefaultContext<PageContextPayload>>(PageContext)
  const {
    callbacks: {
      deleteRelatedEntity,
    },
  } = pageContext

  const relatedEntitiesPayload = useRelatedEntities({
    filters: {
      owner_id: taskList.id,
      owner_type: 'TaskList',
    },
  })

  const { filteredRelatedEntities, hasFilteredRelatedEntities, loading } = relatedEntitiesPayload

  const relatedEntityPayload = useRelatedEntity({ owner_id: taskList.id, owner_type: 'TaskList' })
  const { callbacks: { createOrEditRelatedEntity } } = relatedEntityPayload

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title="Connections">
      <Box flexDirection="column">
        {filteredRelatedEntities.map(relatedEntity => (
          <RelatedEntity
            // @ts-expect-error TS2322
            callbacks={{ deleteRelatedEntity }}
            key={relatedEntity.id}
            relatedEntity={relatedEntity}
          />
        ))}
      </Box>

      <DashboardModule.Footer boxProps={{ borderTop: loading || !hasFilteredRelatedEntities ? 'none' : '1px solid' }}>
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faPlus} />}
          onClick={() => createOrEditRelatedEntity()}
          marginLeft="auto"
          // @ts-expect-error TS2322
          size={['medium', 'small']}
          width={['100%', 'fit-content']}
        >
          Add Connection
        </Button>
      </DashboardModule.Footer>
    </DashboardModule>
  )
}

export default Contacts
